import React from 'react'
import './Attraction.css'
import aeromodelling from './assets/aeromodelling.jpg'
import autoExpo from './assets/autoexpo.png'
import stunt from './assets/Bike.jpg'
import isro from './assets/ISRO.jpg'
import { Zoom } from 'react-awesome-reveal'
import { Link } from 'react-router-dom'

export default function attraction() {
  return (
    <>
    <div className='attraction_outer_container'>
        <h1 className='subtitle slider_h1'>ATTRACTIONS<div className='bottom_line'></div>
        </h1>

        <div className='card_container'>
            <Zoom>
            <div className='card'>
                <img src={aeromodelling} alt="Air Show" />
                <h3>Air Show</h3>
                <span>NOV 11 | 10:00 AM</span>
            </div>
           
            <div className='card'>
                <img src={autoExpo} alt="Auto Expo" />
                <h3>Auto Expo</h3>
                <p>Giveaway worth ₹10,000/-</p>
                <span>NOV 12 | 10:00 AM</span>
            </div>

            <div className='card isro'>
                <img src={isro} alt="ISRO Hackathon" />
                <h3>ISRO Hackathon</h3>
                <span>NOV 11 - NOV 13</span>
            </div>

            <div className='card'>
                <img src={stunt} alt="Stunt Show" />
                <h3>Stunt Show</h3>
                <span>NOV 12 | 4:00 PM</span>
            </div>
            
            </Zoom>
        </div>
    </div>
     <div className='view-event-mobile'>
     <h3>Check out our <Link to="./events" className='gradient-text-background' style={{fontFamily:"iceland",fontSize:"3rem"}}>Events</Link></h3>

 </div>

 </>
  )
}
